/**
 * Compass Pro flat configuration helpers.
 *
 * After the 22-step rework the voltage allow-list is a single flat array of
 * length 22 (no LV/MV/HV bands) and the current allow-list is a single flat
 * array of length 11. SA enablement is a single boolean per channel.
 */

/**
 * The voltage section is "enabled" if any conventional chip is on OR the
 * channel's SA chip is on. Used by the editor to mirror the section header
 * toggle in real time.
 */
export const isVoltageSectionEnabled = (
  voltageAllowedSettings: boolean[],
  adaptiveVoltageAllowed: boolean,
): boolean => voltageAllowedSettings.some(Boolean) || adaptiveVoltageAllowed;

export const isCurrentSectionEnabled = (
  currentAllowedSettings: boolean[],
  adaptiveCurrentAllowed: boolean,
): boolean => currentAllowedSettings.some(Boolean) || adaptiveCurrentAllowed;

/**
 * Find the allow-list index closest to `desired` (1-based). On a tie, prefer
 * the lower index (matches firmware clamp behavior per PRD §5.7). Returns the
 * 1-based setting number, or `null` if no setting is allowed.
 */
export const nearestAllowedConventionalSetting = (
  desired: number,
  allow: boolean[],
): number | null => {
  let best: { index: number; distance: number } | null = null;
  for (let i = 0; i < allow.length; i++) {
    if (!allow[i]) continue;
    const distance = Math.abs(i + 1 - desired);
    if (best === null || distance < best.distance) {
      best = { index: i, distance };
    }
  }
  return best === null ? null : best.index + 1;
};

/**
 *
 * @param {number} [value]
 * @returns
 */
export const mapAlertValuesToString = (value?: number) => {
  switch (value) {
    case 0:
      return 'User Defined';
    case 1:
      return 'Disabled';
    case 2:
      return 'Enabled';
    default:
      return 'Undefined';
  }
};

/**
 *
 * @param {number} [value]
 * @returns
 */
export const mapVoltageRangeToString = (value?: number) => {
  switch (value) {
    case 0:
      return 'User Defined';
    case 1:
      return 'Low';
    case 2:
      return 'Medium';
    case 3:
      return 'High';
    default:
      return 'Undefined';
  }
};

/**
 *
 * @param {number} [value]
 * @returns
 */
export const mapSensitivities = (value?: number) => {
  switch (value) {
    case 0:
      return 'User Defined';
    case 12:
      return 'Smart Adaptive';
    case 13:
      return 'Disabled';
    default:
      return 'Undefined';
  }
};
